import { styled } from '@mui/material';

export const sxStyles = {
  icon: {
    marginRight: '1.875rem',
  },
  title: {
    fontWeight: 700,
  },
};

export const StyledCardWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minHeight: '80px',
  marginBottom: '1.5rem',
  padding: '1.5rem 1.75rem',
  backgroundColor: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderRadius: '8px',
}));
